import React, { useEffect } from 'react';
import { useSelector, useDispatch, shallowEqual  } from 'react-redux';
import { useParams } from 'react-router-dom'; // useParams 추가
import ChanceInfo from '../../../components/chancemng/info/ChanceInfo';

const ChanceInfoContainer = ({ handleGoBack, estimate, orderCount }) => {
  // URL 파라미터 추출 (:id, :step, :tab)
  const { chance, count } = useSelector(({ chanceModule, projectModule }) => ({
    chance: chanceModule?.chance?.chance,
    count: projectModule?.project?.orderCount,
  }), shallowEqual);


  return (
    <ChanceInfo 
      chance={chance} 
      estimate={estimate} 
      orderCount={orderCount} 
      handleGoBack={handleGoBack} 
    />
  );
};

export default ChanceInfoContainer;
